/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as AddressService from './service'
import { AddressPath, IDistrict } from './model'
import { sortingThAddress } from 'helpers/sortingThAddress'

export const findAll = async (params?: any): Promise<{ body: IDistrict[] }> => {
  const response = await AddressService.findAll(AddressPath.DISTRICTS, params)

  sortingThAddress(response.body)

  return response as { body: IDistrict[] }
}
